<template>
  <!-- FIXME: We need to use the TBD field to say if the requestor is a member of group -->
  <div class="d-flex justify-content-between grow-1 flex-wrap result-border pb-2 pt-2">
    <router-link class="fs-7 fw-300" :to="url" >{{ name }}</router-link>
    <div class="d-flex justify-content-end grow-1 align-items-center">
      <span class="tag is-medium spaced mr-2" v-if="memberCount >= 0">{{ memberCount }} members</span>

      <span class="tag is-medium spaced w-80px"
        :class="{'is-primary': public,
              'is-warning': closed,
              'is-danger': private}">{{ privacySettingLabel }}</span>

      <button v-if="isMember || sentLeave" class="button is-danger ml-4 w-90px" :class="loading && 'is-loading'" @click="showConfirm = true">Leave</button>
      <button v-else-if="public" class="button is-success ml-4 w-90px" :class="loading && 'is-loading'" @click="joinTeam">Join</button>
      <button v-else-if="requested || sentRequest" class="button is-primary ml-4 w-90px" :class="loading && 'is-loading'" disabled>Requested</button>
      <button v-else-if="closed" class="button is-success ml-4 w-90px" :class="loading && 'is-loading'" @click="joinTeam">Request</button>
      <button v-else class="button ml-4 w-90px" disabled>Closed</button>
    </div>
    <Confirm
      :show="showConfirm"
      :message.once="confirmMessage"
      :title.once="'Leave Team'"
      :confirmFocus.once="true"
      :completeButtonText.once="'Leave'"
      @confirm="leaveTeam"
      @cancel="showConfirm = false"/>
  </div>
</template>

<script>
import store from '../store'
import Confirm from './Confirm'

import { joinTeam, leaveTeam } from '../actionTypes'

export default {
  name: 'GroupElement',
  computed: {
    url () {
      return `/groups/${this.id}`
    },
    public () {
      return this.privacySetting === 'public'
    },
    closed () {
      return this.privacySetting === 'closed'
    },
    private () {
      return this.privacySetting === 'private'
    },
    privacySettingLabel () {
      return this.privacySetting === 'public' ? 'open' : this.privacySetting
    },
  },
  components: {
    Confirm,
  },
  props: {
    name: {
      type: String,
      required: true,
    },
    id: {
      type: Number,
      required: true,
    },
    memberCount: {
      type: Number,
      default: -1,
    },
    privacySetting: {
      type: String,
      required: true,
    },
    isMember: {
      type: Boolean,
      default: false,
    },
    requested: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    leaveTeam () {
      this.loading = true
      store.dispatch(leaveTeam, this.id)
      .then(() => {
        this.showConfirm = false
        this.loading = false
        this.sentLeave = true
      })
    },
    joinTeam () {
      this.loading = true
      store.dispatch(joinTeam, this.id)
      .then(() => {
        this.loading = false
        this.sentRequest = true
      })
    },
  },
  data () {
    return {
      loading: false,
      showConfirm: false,
      confirmMessage: `Are you sure you want to leave '${this.name}'?`,
      // FIXME: Hacks to handle state after sending request
      // Move stuff to store and then use dispatch/commit
      sentRequest: false,
      sentLeave: false,
    }
  },
}
</script>



// WEBPACK FOOTER //
// GroupElement.vue?13f04079